import { Input } from "shared/components/ui/input";
import constraintsStore from "shared/store/constraintsStore";
import colorsStore from "shared/store/colorsStore";
import { resolveFieldGroup } from "../panelSections";

type InputConstraintsProps = {
  configData: Record<
    string,
    {
      notEditable?: boolean;
      type?: string;
    }
  >;
  formValues: Record<string, string>;
  id: string;
  sectionKey: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  notEditableValue?: string;
  disabled?: boolean;
};

export const InputConstraints = ({
  configData,
  formValues,
  id,
  sectionKey,
  onChange,
  notEditableValue,
  disabled = false,
}: InputConstraintsProps) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const agentChangedPaths = constraintsStore((s) => s.agentChangedPaths);
  const fieldPath = `${resolveFieldGroup(sectionKey, id)}.${id}`;
  const isAgentChanged = agentChangedPaths.includes(fieldPath);

  let borderColor = colorsConfig.gray2;
  let borderSize = 1;
  if (isAgentChanged) {
    borderColor = colorsConfig.orange;
    borderSize = 2;
  }
  // User typing over an agent-changed value clears the orange border for
  // that field — the memory of "agent touched this" is per-field, and a
  // user override is the explicit signal that the user has acknowledged
  // and intentionally replaced the agent's value. We don't compare to the
  // agent's actual value (we don't retain it; see
  // useConstraintsChangeDetection.ts) — any user write to the field is
  // treated as the override.
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isAgentChanged) {
      constraintsStore.getState().acknowledgeFieldEdit(fieldPath);
    }
    onChange(e);
  };

  return !configData[id]?.notEditable ? (
    <>
      <Input
        id={id}
        value={formValues[id]}
        onChange={handleChange}
        className="w-full"
        disabled={disabled}
        style={{
          fontSize: 14,
          borderRadius: 6,
          border: disabled ? '1px solid #e2e5e9' : borderSize + "px solid " + borderColor,
          color: disabled ? '#b0b5bb' : colorsConfig.FinecoBlack,
          margin: 0,
          padding: 10,
          cursor: disabled ? 'not-allowed' : 'text',
        }}
      />
    </>
  ) : (
    <div
      style={{
        fontSize: 14,
        fontWeight: "bold",
        marginLeft: 38,
        marginTop: 10,
      }}
    >
      {notEditableValue}{" "}
      {configData[id]?.type === "percentage" && <span>%</span>}
    </div>
  );
};
